import { useState } from "react";
import { communication } from "@solimat/solimat-web-endpoint";
import { ICreateUserCommunication } from "@solimat/solimat-web-endpoint/lib/communication/dto";

const useGetAllUserCommunicationByUserId = () => {
  const BASE_URL = import.meta.env.VITE_REACT_APP_COMUNICACIONES_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_COMUNICACIONES_KEY || "";
  const apiCommunication = new communication.CommunicationUser(
    BASE_URL,
    FUNCTIONS_KEY
  );

  const [allUserCommunication, setAllUserCommunication] = useState<any>([]);
  const [loadingGetAllUserCommunication, setLoadingGetAllUserCommunication] =
    useState(false);
  const [errorGetAllUserCommunication, setErrorGetAllUserCommunication] =
    useState(null);
  const [isComunicacionHabilitada, setComunicacionHabilitada] = useState(false);
  const getAllUserCommunication = (userId: string) => {
    setLoadingGetAllUserCommunication(true);
    setErrorGetAllUserCommunication(null);
    apiCommunication
      .getAllUserCommunicationByUserId(userId)
      .then((data: any) => {
        setComunicacionHabilitada(data.data.comunicacionHabilitada);
        let dataAllUserCommunications =
          data &&
          data.data.rows.map((item: any) => {
            let communicationType = "";
            if (item.CitaId !== null) {
              communicationType = "Comentario cita";
            } else if (item.visit_id !== null) {
              communicationType = "Comentario visita";
            } else if (item.PrestacionId !== null) {
              communicationType = "Comentario historial";
            } else {
              communicationType = "General";
            }
            return {
              ...item,
              communication_type: communicationType,
            };
          });
        setAllUserCommunication(dataAllUserCommunications);

        setLoadingGetAllUserCommunication(false);
      })
      .catch((err) => {
        console.error("getAllUserCommunication: ", err);
        setErrorGetAllUserCommunication(err);
        setLoadingGetAllUserCommunication(false);
      });
  };
  const getUserCommunicationId = (userId: string, id: string) => {
    setLoadingGetAllUserCommunication(true);
    setErrorGetAllUserCommunication(null);
    apiCommunication
      .getUserCommunicationById(userId,id)
      .then((resp: any) => {
        let dataCommunication = resp && resp.data;
        setAllUserCommunication([dataCommunication]);

        setLoadingGetAllUserCommunication(false);
      })
      .catch((err) => {
        console.error("getUserCommunicationId: ", err);
        setErrorGetAllUserCommunication(err);
        setLoadingGetAllUserCommunication(false);
      });
  };

  return {
    isComunicacionHabilitada,
    getAllUserCommunication,
    getUserCommunicationId,
    allUserCommunication,
    loadingGetAllUserCommunication,
    errorGetAllUserCommunication,
  };
};

export default useGetAllUserCommunicationByUserId;
